import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { userContract } from 'shared/domain/user/userContract';
import { makeEventPublisher } from 'serviceWorker/broadcasts/publishers';

export const broadcastUploadedUser = makeEventPublisher(userContract, DomainMessagesTypes.uploadedEntity);
export const broadcastUpdatedUser = makeEventPublisher(userContract, DomainMessagesTypes.updatedEntity);

export const broadcastDeletedUser = makeEventPublisher(userContract, DomainMessagesTypes.deletedEntity);
